import { IApplicationState, TBoardId } from '../../../types/types';
import { getAuthUser } from '../authUser/selectors/getAuthUser';

export const getMyPermissionId = (
    state: IApplicationState,
    boardId: TBoardId
): string => {
    return getAuthUser(state).permissionId;
};
